module.exports = __webpack_public_path__ + "img/aq.faebed7b.svg";